import requests from "./httpService";

const PolicyServices = {
 
  getPolicyById: async (id, body) => {
    return requests.get(`/airportPickupPolicy/${id}`, body);
  },

  updatePolicy: async (id, body) => {
    return requests.put(`/airportPickupPolicy/update/${id}`, body);
  },

  
};

export default PolicyServices;
